import Main from './ts/Main';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import 'vue-snotify/styles/material.css';
import $ from 'jquery';



$(new Main());
